import waitFor from '@/utils/promises/waitFor'

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY

const render = () => {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`
  document.head.appendChild(script)
}

const execute = async (payload) => {
  await waitFor(() => !!window.grecaptcha?.enterprise?.execute)

  return window.grecaptcha.enterprise
    .execute(SITE_KEY, payload)
    .catch((e) => console.error(e))
}

export default { render, execute }
